module.exports = __webpack_public_path__ + "img/gallery-6.dd114ed6.jpg";